import React from 'react';
import { LoadingComponentProps } from 'react-loadable';

import { Layout } from 'layouts/Layout';

import { ErrorPage } from './ErrorPage';
import { LoadingPage } from './LoadingPage';

export function LoadableLoadingPage({
  error,
  pastDelay,
}: LoadingComponentProps) {
  if (error) {
    return <ErrorPage error={error} />;
  }

  if (pastDelay) {
    return <LoadingPage delay={0} />;
  }

  return <Layout />;
}
